import { createContext } from 'react';

export type BulkAction = 'expand' | 'collapse' | null;

export interface FunnelSectionsVisibilityContextValue {
  // Registry management
  registerSection: (
    id: string,
    hasContent: boolean,
    initiallyExpanded: boolean
  ) => void;
  updateSectionExpanded: (id: string, expanded: boolean) => void;
  // Bulk actions
  expandAll: () => void;
  collapseAll: () => void;
  bulkAction: BulkAction;
  bulkNonce: number;
  // Derived state
  allSectionsClosed: boolean;
  /** Returns the expanded state for a section id */
  getExpanded: (id: string) => boolean;
  /** Subscribe to changes for a specific section id */
  subscribe: (id: string, cb: () => void) => () => void;
}

export const FunnelSectionsVisibilityContext = createContext<
  FunnelSectionsVisibilityContextValue | undefined
>(undefined);
